import Tabs, { Tab } from '@betterfunnel/ui-core/Tabs';
import { useMemo } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export default function SettingsWrapper() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs: Tab[] = useMemo(() => {
    const currentTab = location.pathname.split('/')[4];

    const items = [
      { name: 'General', id: 'general' },
      { name: 'Ad Accounts', id: 'ad-accounts' },
      { name: 'Forms', id: 'forms' },
      { name: 'Content', id: 'content' },
      { name: 'Brand', id: 'brand' },
      // { name: 'Domains', id: 'domains' },
      { name: 'Integrations', id: 'integrations' },
      // { name: 'Billing', id: 'billing' },
      { name: 'Members', id: 'members' },
    ];

    return items.map((item) => ({
      ...item,
      current: currentTab === item.id,
    }));
  }, [location]);

  return (
    <div className="flex h-full flex-col overflow-hidden">
      {/* <div className="flex h-12 w-full flex-col items-start justify-between gap-2 border-b border-gray-300 pb-3">
        <h1 className="text-[28px] font-semibold leading-6 text-gray-900">
          Settings
        </h1>
        <div className="shrink-0"></div>
      </div> */}
      <Tabs
        tabs={tabs}
        onTabClick={(tab) => {
          navigate(`./${tab}`);
        }}
      />
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
